export { default, meta } from "/Users/ryanchenkie/Desktop/code/blog/app/routes/index.tsx";